import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Status codes the *caller* of a request expects and handles itself, so `HttpOnlineInterceptor`
 * must not raise its backend-error modal for them.
 *
 * The interceptor sits closer to the network than the caller's own `catchError`, so a status a
 * caller deliberately treats as a normal outcome — a 404 from a read meaning "no entry", or from a
 * delete meaning "already gone" — would still show the user an error window on its way out. An
 * `HttpContext` is the way to tell the interceptor otherwise: it travels with the request through
 * Angular's `HttpClient` and, unlike a header, is never sent over the wire.
 *
 * Only the listed statuses are suppressed, and only the modal — the request still fails, the
 * caller still gets the `HttpErrorResponse`, and the failure is still logged and tracked. Anything
 * not listed (500, 403, …) shows the modal as before.
 */
export const EXPECTED_HTTP_ERROR_STATUSES = new HttpContextToken<readonly number[]>(() => []);

/**
 * Builds the `HttpContext` for a request whose caller handles `statuses` itself.
 *
 * @param statuses the status codes that must not raise the backend-error modal
 * @returns the context to pass as `HttpClient`'s `context` option
 */
export function expectedHttpErrorStatuses(...statuses: number[]): HttpContext {
    return new HttpContext().set(EXPECTED_HTTP_ERROR_STATUSES, statuses);
}
